<template>
    <div id="create-forms">
        <div class="container" v-if="isCreateFormVisible">
            <h2>{{ $t("form.createForm") }}</h2>
            <h4>{{ $t("form.createOrTransferaForm") }}</h4>
            <div class="card-wrapper" @click="formBuilderOpen">
                <div class="card">
                    <div class="card-content">
                        <div class="card-icon">+</div>
                        <div class="card-title">{{ $t("form.startFromScratch") }}</div>
                        <div class="card-description">{{ $t("form.startWithaBlankForm") }}</div>
                    </div>
                </div>
            </div>
        </div>
        <FormBuilder v-if="formBuilder" :formId="formId" />
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import FormBuilder from "./FormBuilder";

export default {
    name: "CreateForms",
    components: {
        FormBuilder,
    },
    props: {
        formId: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            formBuilder: false,
            isCreateFormVisible: !this.formId,
        };
    },
    computed: {
        ...mapState({
            site: state => state.site.site,
        }),
    },
    methods: {
        ...mapActions({
            createForm: "forms/createForm",
        }),
        async formBuilderOpen() {
            try {
                const siteId = this.site._id;
                const title = "Yeni Form Başlığı";
                const fields = [
                    {
                        type: "title",
                        label: "Başlık",
                        title: {
                            titleText: "Başlık",
                            subTitle: "Form başlığınızı girin",
                            titleSize: "large",
                            titleAlign: "left",
                        },
                    },
                ];

                const form = await this.createForm({ siteId, title, fields });
                console.log("Form oluşturuldu:", form);
                const formId = form._id;

                this.formId = formId;
                this.formBuilder = true;
                this.isCreateFormVisible = false;
            } catch (error) {
                console.error("Form oluşturulamadı:", error);
            }
        },
    },
    watch: {
        formId: {
            immediate: true,
            handler(newFormId) {
                if (newFormId) {
                    this.formBuilder = true;
                    this.isCreateFormVisible = false;
                }
            },
        },
    },
};
</script>

<style lang="scss" scoped>
#create-forms {
    height: 100%;
    //background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    font-family: 'Roboto', sans-serif;

    .container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        padding: 20px;
        background: #fff;
        border-radius: 15px;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
        width: 80%;
        margin: auto;
        max-width: 600px;
        position: relative;
        top: 15%;

        h2 {
            font-size: 2.5rem;
            font-weight: 700;
            margin-bottom: 1rem;
            color: #333;
        }

        h4 {
            font-size: 1.5rem;
            font-weight: 400;
            color: #555;
        }

        .card-wrapper {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 2rem;
        }

        .card {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 200px;
            height: 200px;
            background: #22272d;
            border-radius: 15px;
            cursor: pointer;
            transition: transform 0.3s, box-shadow 0.3s;

            &:hover {
                transform: translateY(-10px);
                box-shadow: 0 15px 25px rgba(0, 0, 0, 0.2);
            }

            .card-content {
                text-align: center;
                color: #fff;

                .card-icon {
                    font-size: 3rem;
                    margin-bottom: 1rem;
                }

                .card-title {
                    margin-top: 1rem;
                    font-size: 1.4rem;
                    font-weight: 600;
                }

                .card-description {
                    font-size: 1rem;
                    color: #d9e2ec;
                }
            }
        }
    }
}
</style>
